import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex w-full flex-col items-center justify-center px-4 py-24 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-file-search-line text-3xl" aria-hidden="true" />
      </span>
      <h1 className="mt-6 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        我们没能找到你要访问的内容，它可能已被移动或删除。
      </p>
      <p className="mt-1 text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-accent-600"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-600"
        >
          <i className="ri-search-line" aria-hidden="true" />
          去搜索内容
        </Link>
      </div>
    </div>
  );
}